import type { IconFactor } from '@/types/elements/icon'
import type { IInputOption, IInputProps } from '../form/input/types'
import type { CSSProperties } from 'vue'
import type { JSX } from 'vue/jsx-runtime'

export const ONE_REM = 16
export const ITEM_HEIGHT_REM = 42 / ONE_REM
export const MAX_VISIBLE_ITEMS = 4

export type SearchDropdownConfig = {
  itemListPlacement?: 'default' | 'left' | 'right' | 'center';
  collapseIcon?: IconFactor;
}

export type SearchDropdownProps = Partial<IInputProps> & {
  hiddenWhenCollapsed?: boolean
  expanded?: boolean
  size?: string;
  onValueChange?: (value: any) => void | Promise<void>;
  icon?: IconFactor;
  itemStyleExpanded?: CSSProperties;
  itemStyleCollapsed?: CSSProperties;
  itemListMinWidth?: string;
  small?: boolean;
  config?: SearchDropdownConfig;
  noSelect?: boolean;
  selectedItemProps?: SelectedItemProps;
}

export interface SelectedItemProps {
  bodyLeft?: () => JSX.Element;
  body?: () => JSX.Element;
  bodyRight?: () => JSX.Element;
  selectedItemComponent?: any;
  selectedItem?: any
}

export type SearchDropdownState = {
  expanded: boolean
  value: any;
  searchString?: string
  addedItems: IInputOption[]
  loading: boolean
}
